import React from "react";
import { string, func, bool } from "prop-types";
import * as style from "./styles.module.scss";

const SearchBox = ({
  className = "",
  value,
  onChange,
  placeholder = "",
  onCloseClick,
  disabled = false,
  onClick = () => {},
}) => {
  return (
    <div
      className={`${className} ${style.searchBox__wrapper}`}
      onClick={onClick}
    >
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={style.searchBox__input}
        disabled={disabled}
      />
      <img
        className={style.searchBox__magnifier}
        src="/images/icons/magnifier.svg"
      />
      {value !== "" && (
        <img
          className={style.searchBox__close}
          src="/images/icons/remove.svg"
          onClick={onCloseClick}
        />
      )}
    </div>
  );
};

SearchBox.propTypes = {
  className: string,
  value: string.isRequired,
  onChange: func.isRequired,
  placeholder: string,
  onCloseClick: func.isRequired,
  disabled: bool,
  onClick: func,
};

export default SearchBox;
